import { PublicPage } from '../base.js';
import { AppConfig } from '../../config.js';
import { setupPasswordToggles } from './ui.js';

export class Register extends PublicPage {
  static timl = `
    section.auth-page[aria-labelledby="register-title"]
      form.stacked-form.auth-form[action="${AppConfig.authServiceApiBaseUrl}/en/1/register" onSuccessRedirect="/registered" method="POST"]
        header.auth-header
          h1#register-title Create an account
          p Get started with Instant Suite.
        input[name="confirmEmailUrl" type="hidden" value="${AppConfig.appBaseUrl}/en/1/confirm-email"]
        .auth-fields
          label.auth-field
            span Email address
            input[name="email" type="email" autocomplete="email" placeholder="you@example.com" required="true"]
          label.auth-field.auth-password-field
            span Password
            input[name="password" type="password" autocomplete="new-password" placeholder="Create a password" required="true"]
            button.auth-password-toggle[type="button" aria-label="Show password" aria-pressed="false"]
              span.auth-eye[aria-hidden="true"]
        .auth-submit-row
          button.auth-primary[type="submit"] Create account
        p.auth-form-note After creating your account, we'll send you an email to verify your address.
        .auth-divider[aria-hidden="true"]
          span or
        p.auth-switch
          span Already have an account?
          a[href="/login"] Log in
  `;

  static javascript() {
    setupPasswordToggles();
  }
}
